import React from "react";
import PhoneFrame from "./phoneFrame";
import styled from "styled-components";
import canvasVideo from "videos/spotifyCanvas.mp4";
import BgImage from "images/png/toolsBg.png";
import leftImg from "images/png/canvasimg1.png";
import rightImg from "images/png/canvasimg2.png";

const SpotifyCanvasTool = () => {
  return (
    <Container>
      <BgContainer src={BgImage} width="100%" height="100%" />
      <PhoneFrame
        width="10rem"
        height="22rem"
        image={leftImg}
        mHeight="19rem"
        mWidth="9rem"
      />
      <PhoneFrame
        width="12.8rem"
        height="28rem"
        video={canvasVideo}
        center
        mHeight="24rem"
        mWidth="11rem"
      />
      <PhoneFrame
        width="10rem"
        height="22rem"
        image={rightImg}
        mHeight="19rem"
        mWidth="9rem"
      />
    </Container>
  );
};

export default SpotifyCanvasTool;

const Container = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding-top: 6rem;
  gap: 2rem;
  position: relative;
  @media only screen and (max-width: 769px) {
    margin-bottom: 2rem;
  }
`;

const BgContainer = styled.img`
  position: absolute;
  top: 0;
  left: 0;
`;
